<template>
  <MSpecimens1View :key="countRefresh"
    @onDataChangedEvent="refreshView"></MSpecimens1View>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import MSpecimens1View from './MSpecimens1View.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Specimens',
  components: {
    MSpecimens1View
  },
  data () {
    return {
      countRefresh: 0
    }
  },
  mounted () {

  },
  methods: {
    refreshView () {
      this.countRefresh++
    }
  }
}
</script>

<style>

</style>
